import { useEffect, useState } from 'react';
import useTranslation from 'next-translate/useTranslation';
import dynamic from 'next/dynamic';

import Banner from '../../home/Banner/Banner';
import InformationModal from '../InformationModal/InformationModal';
import ContactForm from './ContactForm/ContactForm';

const DinamicModal = ({ className, ...props }) => {
  const Component = dynamic(() => import('../Modal/Modal').catch(() => ''));

  return <Component className={className} data-testid='modal' {...props} />;
};

const BusinessContactForm = ({
  bannerData,
  tariffID = null,
  employeeID = '',
  activeModal = false,
  clearTariff = () => null,
  hasEmployeesCount = false,
}) => {
  const { t } = useTranslation();
  const [modalActive, setModalActive] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  useEffect(() => {
    if (activeModal) {
      setModalActive(true);
    }
  }, [activeModal]);

  const closeModal = () => {
    setModalActive(false);
    clearTariff();
  };

  const showSuccessModal = () => {
    closeModal();
    setShowSuccess(true);
  };

  return (
    <>
      {bannerData && (
        <Banner
          buttonText={bannerData?.button_text}
          type={'dark'}
          item={bannerData}
          itemScope
          itemType='https://schema.org/Offer'
        />
      )}
      <DinamicModal
        active={modalActive}
        setActive={closeModal}
        itemScope
        itemType='https://schema.org/ContactPage'
      >
        <ContactForm
          tariffID={tariffID}
          employeeID={employeeID}
          showSuccess={showSuccessModal}
          hasEmployeesCount={hasEmployeesCount}
        />
      </DinamicModal>
      <InformationModal
        type={hasEmployeesCount ? 'dark' : 'white'}
        active={showSuccess}
        onClose={() => setShowSuccess(false)}
        description={t('common:successText')}
        itemScope
        itemType='https://schema.org/Information'
      />
    </>
  );
};

export default BusinessContactForm;
